<template>
    <div class="row">
        <div class="col-md-8 offset-md-2 g-bg-main g-py-30 g-px-30 text-center g-rounded-15">
            <p class="g-color-white">Need to order your frame collection?</p>
            <button v-on:click="ScrollBottom()" class="btn u-btn-blue g-color-white g-rounded-10 g-px-15">Click Here</button>
        </div>
    </div>
</template>
<script>
export default {
     components: {},
    data() {
        return {
            
        }
    },
    methods: {
        ScrollBottom(){
            this.$scrollTo("#PlaceOrder", 300, {
                el: "#PlaceOrder", 
                offset: -100,
                x: false,
                y: true
            });
        }
    }
}
</script>


// WEBPACK FOOTER //
// FrameOrderCollection.vue?3bd00fb6